import React from 'react';
import Head from 'next/head';
import env from '../../env';

const BaseHtmlHeader = () => (
    <Head>
        <title>SVT Play</title>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1" />
        <meta name="format-detection" content="telephone=no" />
        <meta name="theme-color" content="#000000" />

        <meta property="fb:app_id" content={env.FB_APP_ID} />
        <meta property="fb:pages" content={env.FB_PAGES_ID} />
        <link
            rel="preload"
            as="font"
            crossOrigin="crossorigin"
            href="https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Light.woff2"
        />
        <link
            rel="preload"
            as="font"
            crossOrigin="crossorigin"
            href="https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Regular.woff2"
        />
        <link
            rel="preload"
            as="font"
            crossOrigin="crossorigin"
            href="https://www.svtstatic.se/frontend-resources/svtlib-font/svtlib-font-1.2.0/fonts/PublikWeb-Bold.woff2"
        />
        <link
            rel="preload"
            as="font"
            crossOrigin="crossorigin"
            href={`${process.env.ASSET_PREFIX}/_next/static/media/svt-icons-ffcaed4f35385e677b829905147985b3.8fab452bcc82bb309c7a0400655d05f7.woff`}
        />
        <meta name="application-name" content="SVT Play" />
        <link type="text/plain" rel="author" href="/humans.txt"></link>
    </Head>
);

export default BaseHtmlHeader;
